/* import __COLOCATED_TEMPLATE__ from './delinquent-invoices.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import { dropTask } from 'ember-concurrency';
import { absoluteStoryhunterUrl } from 'sh-www/utils/url';

class DelinquentInvoices extends Component {
  @service
  api;

  @service
  moment;

  @service
  store;

  get visibleInvoices() {
    return this.args.outstandingInvoices
      ? this.args.outstandingInvoices.slice(0, 5)
      : [];
  }

  get additional() {
    return this.args.outstandingInvoices
      ? Math.max(0, this.args.outstandingInvoices.length - 5)
      : 0;
  }

  @action
  computeOverdue(invoice) {
    const now = this.moment.moment();
    const overdueAt = this.moment.moment(invoice.overdueAt);
    return now.diff(overdueAt, 'days');
  }

  @action
  onDownloadPDFClicked(invoice) {
    window.open(absoluteStoryhunterUrl(`/sh-invoices/${invoice.id}/pdf`));
  }
}

export default DelinquentInvoices;
